/**
 * The player's own lockup offline: Lockup 7 on Pilcher Ginnel (the one the key opens, by the safehouse), else
 * the first lockup in the layout. The book, the landlord's note and the "what next" tracker all point here —
 * they used to take the first lockup in the layout (Arch 14, across the borough) and sent the player to a door
 * that does nothing.
 */
export const PLAYER_LOCKUP_ID = 'lockup-pilcher-7';

export function playerLockupPoi<T extends { id: string; kind: string }>(pois: readonly T[]): T | undefined {
  return pois.find((p) => p.id === PLAYER_LOCKUP_ID) ?? pois.find((p) => p.kind === 'lockup');
}
